const ROOT_URI = '/api/documents/';

export default {
  DOCUMENT_UPLOAD_HISTORY: `${ROOT_URI}`,
  DOCUMENT_UPLOAD_HISTORY_API: (version: string) => `${ROOT_URI}/v${version}/uploadedDocuments`,
};
